import { Type } from 'typebox';
import { DailyMessages, InstantMessage, MessagingMetadata, TypeBoxShortIsoCalendarDateFormat, toShortIsoLocalDate } from '@tadpoles/common';
import { MultipartClient } from '../core/multipart.js';
export const MessagingMetadataPayload = Type.Object({
    metadata: Type.Array(MessagingMetadata)
});
export const MessagingMessagesPayload = Type.Object({
    messages: Type.Record(Type.String(), DailyMessages)
});
export const MessagingBookmarkRequest = Type.Object({
    subjectKey: Type.String({ minLength: 1 }),
    latestTimestamp: Type.Number()
});
export const MessagingBookmarkPayload = Type.Void();
export const MessagingSendMessagePayload = Type.Object({
    message: InstantMessage,
    subjectKey: Type.String({ minLength: 1 }),
    date: Type.String({ format: TypeBoxShortIsoCalendarDateFormat }),
    revision: Type.Integer()
});
export const MessagingSendMessageRequest = Type.Object({
    subjectKey: Type.String({ minLength: 1 }),
    message: InstantMessage,
    knownRevision: Type.Optional(Type.Integer())
});
export class HttpMessagingResource {
    static #RecentMessagesBefore = '4001-01-01';
    #httpClient;
    #multipart;
    constructor(httpClient) {
        this.#httpClient = httpClient;
        this.#multipart = new MultipartClient(httpClient);
    }
    async getMetadata(options) {
        return await this.#httpClient.get({
            path: '/messaging/metadata',
            payloadSchema: MessagingMetadataPayload,
            signal: options?.signal
        });
    }
    async getMessages(subjectKey, before = HttpMessagingResource.#RecentMessagesBefore, options) {
        return await this.#httpClient.get({
            path: '/messaging/messages',
            queryParams: {
                subjectKey,
                before: before instanceof Date ? toShortIsoLocalDate(before) : before
            },
            payloadSchema: MessagingMessagesPayload,
            signal: options?.signal
        });
    }
    async bookmark(subjectKey, timestamp, options) {
        if (!Number.isFinite(timestamp)) {
            throw new Error('Messaging bookmark timestamps must be finite millis');
        }
        return await this.#httpClient.post({
            path: '/messaging/bookmark',
            body: {
                subjectKey,
                latestTimestamp: timestamp
            },
            bodySchema: MessagingBookmarkRequest,
            payloadSchema: MessagingBookmarkPayload,
            signal: options?.signal
        });
    }
    async sendMessage(request, options) {
        return await this.#multipart.postMultipart({
            path: '/messaging/message',
            attachments: request.message.attachments,
            body: request,
            bodySchema: MessagingSendMessageRequest,
            payloadSchema: MessagingSendMessagePayload,
            signal: options?.signal
        });
    }
}
